import {
  CampaignEmailTemplateTypeMap,
  IOutreachEmail,
  IOutreachEmailRes,
  IOutreachEmailTemplate,
} from '../models/outreach-email.models';

export const baseOutreachEmailTemplateMock: IOutreachEmailTemplate = {
  templateId: 'template-id',
  templateType: CampaignEmailTemplateTypeMap.connect,
  name: 'template-name',
  favorite: false,
  suggested: false,
  templateContent: {
    content: 'content',
    subject: 'subject',
    preheader: 'preheader',
  },
  tags: ['1'],
};

export const baseOutreachEmailMock: IOutreachEmail = {
  email: {
    recipientAddress: ['recipient@user.example'],
    templateId: 'templateId1',
    senderUserId: 'senderUserId1',
    currency: 'USD',
    honorarium: 100,
    sendTime: '2023-01-12T14:00:00.000Z',
    templateContent: {
      content: 'content1',
      preheader: 'preheader1',
      subject: 'subject1',
    },
  },
  expertId: 'expertId1',
};

export const baseOutreachEmailResMock: IOutreachEmailRes = {
  expertId: 'expertId1',
  emails: [{ emailId: 'email-1', address: 'recipient@user.example' }],
};
